import { gql } from '@apollo/client';

export const RESET_OFFICER_PASSWORD = gql`
  mutation resetOfficerPassword($username: String!) {
    resetOfficerPassword(username: $username)
  }
`;
